import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import {
  store,
  addKitchenTable,
  editKitchenTable,
  removeKitchenTable
} from "@redux"
import {
  addTable,
  deleteOrder,
  deleteTable,
  editTable,
  getOrders
} from "services"

let tables = []

const useTdOnBlur = (t) => {
  const dispatch = useDispatch()

  const branchId =
    useSelector(state => state.userAccountInfo.branchId)

  tables = [...t]

  const deleteTablePendingOrders = async (tableNumber) => {
    const response =
      await getOrders({
        branchId,
        skip: 0,
        limit: 30,
        sortBy: "newstOrder",
        statusMultiple: ["pending"],
        tableNumber
      })

    response.forEach(order => {
      deleteOrder(order._id)
    })
  }

  const getTablesChanges = () => {
    const { kitchenTables } = store.getState()

    const kitchenTablesMap = {}

    kitchenTables.forEach(kitchenTable => {
      kitchenTablesMap[kitchenTable._id] = kitchenTable
    })

    const newTables = []
    const editedTables = []
    const removedTables = []

    kitchenTables.forEach(kitchenTable => {
      const isDeleted =
        !tables.some(t =>
          !!t._id &&
          t._id === kitchenTable._id
        )

      isDeleted &&
        removedTables.push({
          _id: kitchenTable._id,
          tableNumber: kitchenTable.tableNumber
        })
    })

    tables.forEach(table => {
      if (!table._id) return newTables.push(table)

      const previousTable = kitchenTablesMap[table._id]

      if (table.tableNumber !== previousTable.tableNumber) {
        return editedTables.push(table)
      }

      if (table.capacity !== previousTable.capacity) {
        return editedTables.push(table)
      }

      if (table.shape !== previousTable.shape) {
        return editedTables.push(table)
      }

      if (table.scale !== previousTable.scale) {
        return editedTables.push(table)
      }

      if (table.position.x !== previousTable.position.x) {
        return editedTables.push(table)
      }

      if (table.position.y !== previousTable.position.y) {
        return editedTables.push(table)
      }
    })

    return {
      newTables,
      editedTables,
      removedTables
    }
  }

  const handleSave = async () => {
    const {
      newTables,
      editedTables,
      removedTables
    } = getTablesChanges()

    try {
      Promise.all([
        ...newTables.map(async newTable => {
          const response =
            await addTable({ ...newTable, branchId })

          dispatch(
            addKitchenTable(response)
          )
        }),
        ...editedTables.map(async editedTable => {
          const response =
            await editTable(
              editedTable._id,
              { ...editedTable, branchId }
            )

          dispatch(
            editKitchenTable(response._id, response)
          )
        }),
        ...removedTables.map(async removedTable => {
          dispatch(
            removeKitchenTable(removedTable._id)
          )

          deleteTablePendingOrders(
            removedTable.tableNumber
          )

          deleteTable(removedTable._id)
        })
      ])
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    return () => {
      handleSave()
    }
  }, [])
}

export default useTdOnBlur